import apiClient from '@u/apiClient'
import GetItemStockSummaryController from '@/wayfinder/actions/App/Http/Controllers/ItemStock/GetItemStockSummaryController'
import GetStockByLocationController from '@/wayfinder/actions/App/Http/Controllers/Stock/GetStockByLocationController'
import GetStockableItemsController from '@/wayfinder/actions/App/Http/Controllers/Item/GetStockableItemsController'
import GetItemForStockController from '@/wayfinder/actions/App/Http/Controllers/ItemStock/GetItemForStockController'
import GetItemStockController from '@/wayfinder/actions/App/Http/Controllers/ItemStock/GetItemStockController'
import UpdateLocationToItemStockController from '@/wayfinder/actions/App/Http/Controllers/ItemStock/UpdateLocationToItemStockController'
import PrintItemStockLabelController from '@/wayfinder/actions/App/Http/Controllers/ItemStock/PrintItemStockLabelController'

export default {
  getSummary() {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemStockSummaryController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getStockByLocation({}, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetStockByLocationController.get({ location: payload.location_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getStockableItem() {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetStockableItemsController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getItem({}, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemForStockController.get({ item: payload.item_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getItemStock({}, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetItemStockController.get({ item_stock: payload.item_stock_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateStockItemLocation({}, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateLocationToItemStockController.put({
            item_stock: payload.item_stock_id
          }),
          {
            location_id: payload.location_id
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  printLabelItemStock({}, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(PrintItemStockLabelController.get({ item: payload.item_id }), {
          params: payload.params
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  setDataTransferObject({ commit }, payload) {
    commit('setDataTransferObject', payload)
  }
}
